import { motion } from "framer-motion";
import {
  Factory,
  HeartPulse,
  Plane,
  Laptop,
  Calculator,
  Scale,
  HardHat,
  Wrench,
} from "lucide-react";
import { INDUSTRIES } from "@/lib/mockData";
import { HOME } from "@/constants/testIds";

const EASE = [0.22, 1, 0.36, 1];

const ICONS = {
  factory: Factory,
  "heart-pulse": HeartPulse,
  plane: Plane,
  laptop: Laptop,
  calculator: Calculator,
  scale: Scale,
  "hard-hat": HardHat,
  wrench: Wrench,
};

const Industries = () => {
  return (
    <section id="industries" className="relative py-20 md:py-28 bg-brand-surface">
      <div className="px-5 md:px-10 lg:px-16">
        <div className="flex flex-col items-center text-center mb-14 md:mb-20">
          <div className="text-xs md:text-sm font-display font-semibold tracking-[0.2em] uppercase text-brand-red mb-3">
            What We Cover
          </div>
          <h2 className="section-heading section-heading-center font-display font-bold text-4xl md:text-5xl text-brand-ink">
            Industries We Serve
          </h2>
          <p className="mt-6 max-w-2xl text-brand-slate text-base md:text-lg leading-relaxed">
            Eight verticals, thousands of placements, one operating standard —
            we hire for the roles others struggle to fill.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {INDUSTRIES.map((ind, i) => {
            const Icon = ICONS[ind.icon] || Factory;
            return (
              <motion.div
                key={ind.slug}
                initial={{ opacity: 0, y: 22 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.55, ease: EASE, delay: 0.04 * i }}
                whileHover={{ y: -4 }}
                data-testid={HOME.industryItem(ind.slug)}
                className="group relative bg-white rounded-xl border border-brand-border p-6 md:p-8 flex flex-col items-center text-center card-soft cursor-pointer overflow-hidden transition-shadow hover:shadow-[0_16px_40px_rgba(15,23,42,0.10)]"
              >
                <div className="relative w-16 h-16 md:w-20 md:h-20 rounded-xl bg-brand-blue-light/60 flex items-center justify-center mb-5 md:mb-6 transition-colors group-hover:bg-brand-blue-light">
                  <Icon className="w-8 h-8 md:w-10 md:h-10 text-brand-blue" strokeWidth={1.5} />
                  <span className="absolute -top-1 -right-1 w-3 h-3 rounded-full bg-brand-red" />
                </div>
                <div className="font-display font-bold text-brand-ink text-base md:text-lg leading-snug">
                  {ind.name}
                </div>
                <div className="mt-4 h-0.5 w-8 bg-brand-red/0 group-hover:bg-brand-red transition-all group-hover:w-14" />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Industries;
